import { useEffect } from 'react';

export const useSeasonFromSearchParams = <T extends { season: string }>(
	searchParams: URLSearchParams | null,
	setFilters: React.Dispatch<React.SetStateAction<T>>,
	season?: string
) => {
	useEffect(() => {
		if (searchParams?.get('season')) {
			setFilters((filters) => ({
				...filters,
				season: searchParams.get('season') ?? ''
			}));
		} else {
			setFilters((filters) => ({
				...filters,
				season: season ?? ''
			}));
		}
	}, [searchParams, setFilters]);
};
